import React from "react";
import "./AcceptInvitePage.css";

type Props = {
  adminEmail?: string | null;
  /** The server answered that this person has no company (removed by an
   *  admin, or never added). This device's copy of company data has already
   *  been wiped (App.tsx loadOrgForUser). */
  removed?: boolean;
  onLogout?: () => void;
};

/**
 * Shown to a signed-in person who belongs to no company. Same card as the
 * login and invite pages (AcceptInvitePage.css). The old version used
 * Tailwind classes the app doesn't load, so it rendered unstyled.
 */
export default function AccessRevoked({ adminEmail, removed, onLogout }: Props) {
  return (
    <div className="ai-page">
      <main className="ai-card" aria-label="No access">
        <img src={`${process.env.PUBLIC_URL}/icon-192.png`} alt="" className="ai-logo" />
        <h1 className="ai-title">{removed ? "Access removed" : "No company access"}</h1>
        <p className="ai-sub">
          {removed
            ? "Your access to The Estimator has been removed, so your company's data is no longer available on this device."
            : "This login isn't part of a company on The Estimator."}{" "}
          Contact your company's admin{adminEmail ? ` (${adminEmail})` : ""} if you think this is a
          mistake.
        </p>
        {onLogout ? (
          <button type="button" className="ai-primary" onClick={onLogout}>
            Log out
          </button>
        ) : null}
      </main>
    </div>
  );
}
